import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["customs", "statistical"];

  sync() {
    const value = parseFloat(this.customsTarget.value);
    if (isNaN(value)) return;

    this.statisticalTarget.value = Math.round(value);
  }
}
